<template>
  <AppModal
    :visible="value"
    persistent
    :close-button="true"
    :is-fixed-top="true"
    :max-width="750"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    @close="close()"
  >
    <template #title>
      <EntranceFamilies :style="contentMargin" />
    </template>
    <template #content>
      <SimilarActions
        :style="contentMargin"
        @changeChosenFamily="chosenFamily = $event"
        @changeChosenOption="chosenOption = $event"
        @changeOverwriteFamily="overwriteFamily = $event"
      />
      <v-divider />
    </template>
    <template #actions>
      <v-layout
        justify-end
        :column="$vuetify.breakpoint.xsOnly"
      >
        <v-btn
          color="sz_transparent"
          @click="close()"
        >
          {{ $t('buttons.cancel') }}
        </v-btn>
        <v-btn
          color="sz_violet"
          :loading="loading"
          :disabled="isButtonDisabled"
          :class="[{ 'ml-0 mt-3': $vuetify.breakpoint.xsOnly }]"
          @click="sendAnswer()"
        >
          {{ $t('buttons.write') }}
        </v-btn>
      </v-layout>
    </template>
  </AppModal>
</template>

<script>
import EntranceFamilies from '@/components/widgets/addFamily/familySimilar/EntranceFamilies';
import SimilarActions from '@/components/widgets/addFamily/familySimilar/SimilarActions';
import overwriteSimilarFamilies from '@/mixins/overwriteSimilarFamilies';
import AppModal from '@/components/widgets/AppModal.vue';

export default {
    name: 'FamilySimilar',
    components: { AppModal, EntranceFamilies, SimilarActions },
    mixins: [overwriteSimilarFamilies],
    inject: ['$validator'],
    props: {
        value: {
            type: Boolean,
            required: true
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        chosenFamily: null,
        chosenOption: null,
        overwriteFamily: null
    }),
    computed: {
        contentMargin () {
            return this.$vuetify.breakpoint.xsOnly ? false : 'margin-left: 38px;';
        },
        isButtonDisabled () {
            return (
                this.loading ||
        this.cannotOverwriteFamily ||
        this.noFamiliesForOverwrite ||
        !this.canOverwriteFamily
            );
        }
    },
    methods: {
        clearData () {
            this.chosenFamily = null;
            this.chosenOption = null;
            this.overwriteFamily = null;
        },
        close () {
            this.$emit('close');
        },
        sendAnswer () {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.$store.commit('familyData/setSimilarityParameters', {
                        chosenFamily: this.chosenFamily,
                        chosenOption: this.chosenOption,
                        overwriteFamily: this.overwriteFamily
                    });
                    switch (this.chosenOption) {
                    case 1:
                        this.$emit('forDecision');
                        break;
                    case 2:
                        this.$emit('overwriteFamily');
                        break;
                    case 3:
                        this.$emit('addNewFamily');
                        break;
                    }
                    this.clearData();
                }
            });
        }
    }
};
</script>

<style scoped></style>
